// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"669":"07677941","727":"bc2b06bd","755":"64436e6d","787":"883f1fe7","955":"e8b2fbd5"}[chunkId] + ".chunk.js";
};